var cov_5goyq74gz = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Slider/styles/index.js",
      hash = "36a1f12d0d7256944eee23ea20600d03d7ee112e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Slider/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 27
        },
        end: {
          line: 5,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var sliderLess = {};
import genaration from '../../utils/classname';
export var sliderClass = (cov_5goyq74gz.s[0]++, genaration(sliderLess, 'slider'));